import type { IconData } from '@stacksjs/iconify-core'

export const userSingleNeutralMale: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M38 17c0 7.732-6.268 14-14 14s-14-6.268-14-14S16.268 3 24 3s14 6.268 14 14\"/><path d=\"M18.352 29.814c-5.094 1.519-9.077 5.036-10.637 9.44c-.846 2.39.907 4.637 3.417 4.994C13.829 44.63 17.986 45 24 45s10.17-.37 12.868-.752c2.51-.357 4.264-2.604 3.417-4.994c-1.56-4.404-5.543-7.921-10.637-9.44M38 17c-7.732 0-14-6.268-14-14c0 7.732-6.268 14-14 14m18 6.5c-1.75 2.667-6.25 2.667-8 0M19 18v.5m10.001-.5v.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userSingleNeutralMale
